import { SearchState } from '../../../models';
import { removeHTMLTags } from '../../../utils';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class SetQueryMutation implements SearchMutation {

  mutations = {
    [SEARCH_MUTATIONS_KEYS.setQuery]: (searchState: SearchState, query: string) => {
      searchState.query = removeHTMLTags(query)
        .trim();
    }
  };
}
